export default {
    loading: 'Cargando...',
    and: ' y ',
    authenticating: 'Iniciando sesión...',
    exiting: 'Saliendo...',
}
